<template lang="pug">
	modal(:maxWidth="960")
		.card.text-left
			.card-header
				span.fa.fa-info-circle.mr-2
				| Recinto
				button.close(@click="cerrar") &times;
			.card-body.bg-light(style="border-bottom: 1px solid #e0e0e0;")
				div.detallesSeleccion
					div(v-if="objetivo")
						b Objetivo
						|  {{objetivo}}
					div(v-if="objetivo")
						b Seleccionados
						|  {{seleccion.length}}
					div(v-if="objetivo")
						b Pendientes
						|  {{objetivo - seleccion.length}}
					div
						.input-group
							.input-group-prepend
								.input-group-text
									span.fa.fa-user
							input.form-control.form-control-sm(placeholder="Búsqueda" v-model="cadena")
				div.detallesSeleccion.max
					div
						| Capacidad recinto
						br
						b {{capacidad}}
					div
						| Ocupación
						br
						b {{ocupadas}} ({{ocupadas * 100 / capacidad | round(2)}} %)
					div
						| Libres
						br
						b {{capacidad - ocupadas}}
			.card-body(v-if="evento && ocupacion && evento.RecintoID")
				.zona(
					v-for="(zona, z) in filas"
					:key="'zona-' + z"
				)
					.tituloZona
						span {{zona.nombre}}
						span.ocupacion {{zona.asientosOcupados}} de {{zona.asientosTotal}} localidades ocupadas. <b>{{zona.asientosTotal - zona.asientosOcupados}} libres</b>
						div.pull-right(@click="toggleZona(zona.ZonaID)", style="cursor: pointer")
							span(v-if="zonaActiva(zona.ZonaID)" style="color: red") Ocultar
							span(v-else, style="color: green;") Mostrar
					.fila(
						v-for="fila in zona.filas"
						:key="fila.Numero"
						v-if="zonaActiva(zona.ZonaID)"
					)
						.numero {{ fila.Nombre }}
						Asiento.asi(
							v-for="(asiento, i) in fila.Asientos"
							:key="fila.Numero + '-' + asiento.Numero + '' + i "
							:asiento="asiento"
							@pulsado="doClick(asiento)",
							:cadena="cadena"
						)
			.card-body.bg-danger.text-white(v-else-if="evento && !evento.RecintoID")
				h2 Este evento no tiene recinto asignado
			.card-body.text-center(v-else)
				h2 Cargando
			.card-footer(v-if="evento && evento.RecintoID && objetivo")
				button.btn.btn-primary(@click="confirmar" :disabled="seleccion.length !== objetivo")
					span.fa.fa-check.mr-2
					| Confirmar
</template>

<script>
import Asiento from './asiento'
import API from '../../api'
export default {
	props: ['EventoID', 'objetivo', 'asientos'],
	data () {
		return {
			evento: null,
			ocupacion: null,
			seleccion: [],
			cadena: null,
			zonas: new Map()
		}
	},
	components: {
		Asiento
	},
	created () {
		if (this.asientos) {
			this.seleccion = this.asientos.filter(a => {
				return (a.Fila && a.Asiento)
			}).map(a => {
				const asiento = a.Fila.toString() + '-' + a.Asiento.toString()
				return asiento
			})
		}

		API.getRecinto(this.EventoID)
			.then(res => {
				this.evento = res.data
				this.calculaOcupacion()
			})
			.catch(e => {
				console.error(e)
			})
	},
	computed: {
		capacidad () {
			if (!this.evento || !this.evento.Recinto) {
				return 0
			}

			return this.evento.Recinto.Filas.reduce((acum, fila) => {
				acum = acum + fila.Localidades
				return acum
			}, 0)
		},
		ocupadas () {
			if (!this.evento || !this.evento.Recinto) {
				return 0
			}

			return this.evento.Invitados.reduce((acum, invitado) => {
				if (invitado.Localidades && invitado.Estado !== 'Denegado' && invitado.Localidades.length > 0) {
					acum = invitado.Localidades.reduce((a, i) => {
						if (i.Fila && i.Asiento) {
							a = a + 1
						}
						return a
					}, acum)
				}

				return acum
			}, 0)
		},
		filas () {
			const res = this.evento.Recinto.Filas.map(fila => {
				const asientos = fila.Patron.split('')
				let numeroAsiento = 0
				fila.Asientos = asientos.map(a => {
					numeroAsiento = (a === 'A') ? numeroAsiento + 1 : numeroAsiento
					const coordenadas = fila.Numero.toString() + '-' + numeroAsiento
					const asiento = {
						Etiqueta: a,
						Ocupado: (a !== 'A') ? false : (this.ocupacion.has(coordenadas) && this.seleccion.indexOf(coordenadas) < 0),
						Numero: (a === 'A') ? numeroAsiento : null,
						Fila: fila.Numero,
						Datos: (this.ocupacion.has(coordenadas)) ? this.ocupacion.get(coordenadas) : null,
						Coordenadas: coordenadas,
						Seleccionado: (this.seleccion.indexOf(coordenadas) >= 0),
						ColorFondo: fila.ColorFondo,
						ColorLetra: fila.ColorLetra
					}

					return asiento
				})
				return fila
			}).reverse().reduce((acum, fila) => {
				const zona = fila.ZonaID || 0
				const totalFila = fila.Localidades
				const ocupados = fila.Asientos.reduce((sum, asiento) => {
					if (asiento.Ocupado) {
						sum = sum + 1
					}
					return sum
				}, 0)
				if (!acum.has(zona)) {
					acum.set(zona, {
						nombre: fila.ZonaNombre,
						ZonaID: fila.ZonaID,
						filas: [fila],
						asientosTotal: totalFila,
						asientosOcupados: ocupados
					})
				} else {
					const z = acum.get(zona)
					z.filas.push(fila)
					z.asientosTotal += totalFila
					z.asientosOcupados += ocupados
					acum.set(zona, z)
				}
				return acum
			}, new Map())

			return Array.from(res).map(a => a[1])
		}
	},
	methods: {
		calculaOcupacion () {
			this.ocupacion = this.evento.Invitados.reduce((acum, invitado) => {
				for (let i = 0; i < invitado.Localidades.length; i++) {
					const coordenadas = invitado.Localidades[i].Fila.toString() + '-' + invitado.Localidades[i].Asiento.toString()
					if (this.seleccion.indexOf(coordenadas) < 0) {
						acum.set(coordenadas, {
							Asistente: invitado,
							Persona: invitado.Localidades[i]
						})
					}
				}

				return acum
			}, new Map())
		},
		doClick (asiento) {
			if (!this.objetivo) {
				return
			}

			const ind = this.seleccion.indexOf(asiento.Coordenadas)

			if (ind < 0 && this.objetivo > this.seleccion.length) {
				if (asiento.Ocupado) {
					return
				}
				this.seleccion.push(asiento.Coordenadas)
			} else if (ind >= 0) {
				this.seleccion.splice(ind, 1)
			}
		},
		confirmar () {
			const asientos = []
			for (let i = 0; i < this.seleccion.length; i++) {
				const coord = this.seleccion[i].split('-')
				asientos.push({
					Fila: parseInt(coord[0]),
					Asiento: parseInt(coord[1])
				})
			}
			this.$emit('confirmar', asientos)
			this.cerrar()
		},
		zonaActiva (ZonaID) {
			if (!this.zonas.has(ZonaID)) {
				return true
			}
			return this.zonas.get(ZonaID)
		},
		toggleZona (ZonaID) {
			if (!this.zonas.has(ZonaID)) {
				this.zonas.set(ZonaID, false)
			} else {
				const zona = this.zonas.get(ZonaID)
				this.zonas.set(ZonaID, !zona)
			}
			this.$forceUpdate()
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>

<style scoped>
.zona {
	position: relative;
	display: block;
	margin-top: 15px;
	padding-top: 10px;
	border-top: 1px solid #aaaaaa;
}
.tituloZona {
	position: relative;
	display: block;
	font-weight: bold;
	margin: 5px;
}

.zona > .tituloZona > span {
	margin-right: 10px;
}

.zona > .tituloZona > span.ocupacion {
	color: blue;
	font-weight: normal;
}
.fila {
	display: flex;
	flex-direction: row-reverse;
	flex-flow: row-reverse;
	flex-wrap: nowrap;
}

.fila > .numero {
	width: 40px;
	height: 20px;
	margin-left: 3px;
	margin-right: 3px;
	padding-right: 2px;
	padding-left: 2px;
	background-color: #111111;
	text-align: center;
	color: white;
}
/* .fila > .asi {
	width: 20px;
	height: 20px;
	margin-top: 5px;
} */

.detallesSeleccion {
	display: flex;
	flex-direction: row;
	flex-flow: row;
	width: 100%;
	align-content: stretch;
	align-items: stretch;
	align-self: stretch;
	justify-self: stretch;
}

.detallesSeleccion > div {
	flex-grow: 1;
	text-align: center;
}

.detallesSeleccion.max > div {
	padding: 20px;
	padding-bottom: 0;
	color: #431f86;
	font-size: 1.5em;
	flex-grow: 1;
	text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/modulos/invitaciones/vue/components/editor/verRecinto.vue